import { render, staticRenderFns } from "./p1s1MyConversations.vue?vue&type=template&id=f3c7cffc"
import script from "./p1s1MyConversations.vue?vue&type=script&lang=js"
export * from "./p1s1MyConversations.vue?vue&type=script&lang=js"
import style0 from "./p1s1MyConversations.vue?vue&type=style&index=0&id=f3c7cffc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports